<ze-report-viewer-view *ngIf="reviewId" [fromCodeReview]="true" [reviewId]="reviewId" (onChangeReport)="onChangeReport(dialogTemplate, $event)"></ze-report-viewer-view>

<!-- Add this to your HTML file -->
<ng-template #dialogTemplate let-dialogRef>
    <div class="changeReport">
        <h2 mat-dialog-title>Update Report</h2>
        <form [formGroup]="reportUpdateForm" (ngSubmit)="onSubmitChange()">
            <ul>
                <li>
                    <mat-select formControlName="reportArtifact" required
                        (selectionChange)="onReportArtifactChange($event.value)">
                        <mat-option *ngFor="let reportArtifact of reportArtifactNameOptions" [value]="reportArtifact">
                            {{ reportArtifact.artifactName }}
                        </mat-option>
                    </mat-select>
                </li>
                <li>
                    <mat-select formControlName="report">
                        <mat-option *ngFor="let report of artifactReports" [value]="report">
                            <span>
                                {{ report.startTime | date:'MMM d, yyyy, h:mm a' }} | {{ report.createdBy}}
                            </span>
                        </mat-option>
                    </mat-select>
                </li>
            </ul>
            <div class="update-report-btn">
                <button type="submit" [disabled]="!reportUpdateForm.valid" [featureActionState]="'CODE_REVIEW'">Submit</button>
                <button type="button" (click)="closeDialog()">Cancel</button>
            </div>
        </form>
    </div>    
  </ng-template>
  